module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid49_960x853.a118a4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid49_960x853.jpg
// module id = XTV4
// module chunks = 0